//import { configureStore, createSlice } from '@reduxjs/toolkit';
import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { GETALLENTERPRISE } from "../../api/api";

export const fetchEnterprises = createAsyncThunk(
  "GetAllEnterprise",
  async ({ header }, { getState }) => {
    const {enterprises, enterprisesChanges} = getState().enterpriseDataSlice;
    if(enterprises.length > 0 && !enterprisesChanges){
      return enterprises;
    }
    const response = await GETALLENTERPRISE(header); 
    return response.data.data;
  }
);

const dropdownSlice = createSlice({
  name: 'dropdown',
  initialState: {
    enterprises: [],
    enterprisesChanges: false,
    loading: false,
    error: null,
  },
  reducers: { 
    setEnterprisesChanges: (state, action) => {
      state.enterprisesChanges = action.payload;
    }
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchEnterprises.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchEnterprises.fulfilled, (state, action) => {
        state.loading = false;
        state.enterprises = action.payload;
        state.enterprisesChanges = false;
      })
      .addCase(fetchEnterprises.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
      });
  },
});

export const {setEnterprisesChanges} = dropdownSlice.actions;

export default dropdownSlice.reducer;